/**
 * Single source of truth for the default event-staff invite subject.
 *
 * The string carries two forms:
 *  - `DEFAULT_SUBJECT_TEMPLATE` is the handlebars form actually rendered
 *    server-side when the seller hasn't overridden the subject (mirrors
 *    apps/api/mail/templates/index.js → 'event-staff-invite'.subject).
 *  - `formatDefaultSubject(eventTitle)` interpolates an event name for
 *    UI display (Step 3 review row, the input placeholder, etc.).
 *
 * Keeping the pattern here means the wizard always shows the merchant
 * what they'll actually get — and changing the default in one place
 * keeps the wire-level subject + every UI surface in lockstep.
 */

export const DEFAULT_SUBJECT_TEMPLATE = 'Event staff invitation for {{event.title}}';

export function formatDefaultSubject(eventTitle?: string): string {
  return `Event staff invitation for ${eventTitle?.trim() || 'your event'}`;
}
